const Work_Data = [
  {
    id: 1,
    cover: "https://tranquil-licorice-79e76f.netlify.app/images/works/work-1.png",
    title: "Search Multiple Destinations",
    desc: "Booking hotels for multiple destinations is a breeze. You can manage all your reservations in one place, ensuring a smooth and well-organized trip."
  },
  {
    id: 1,
    cover: "https://tranquil-licorice-79e76f.netlify.app/images/works/work-3.png",
    title: "Find the Lowest Hotel Prices",
    desc: "Compare deals from hundreds of sites in just one search. This ensures you get the best value for your money, making your travel experience not only memorable but also affordable. Happy travels! 🌍",
  },
  {
    id: 1,
    cover: "https://tranquil-licorice-79e76f.netlify.app/images/works/work-2.png",
    title: "Find the Right Hotel for You",
    desc: "To find accommodations that suit your preferences and budget. Whether you’re looking for a luxurious suite or a cozy budget room, these platforms make it easy to find your ideal hotel. Enjoy your stay! 🏨",
  },
]
export default Work_Data;